import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ApplyForm from "./ApplyForm";

const WebDeveloper: React.FC = () => {
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Career details" pagesub=" Full Stack Web Developer" />
                        <section className="career-details">
                            <div className="container">
                                <div className="cp-details-wrap">

                                    {/* Manager Info */}
                                    <div className="cp-manager_info">
                                        <h2 className="details-content-title mb-30">
                                            Full Stack Web Developer – (Full-time)
                                        </h2>

                                        <ul className="xb-details-content list-unstyled mb-35">
                                            <li><span>Department :</span> Engineering & Product Development</li>
                                            <li><span>No. of Openings :</span> (3)</li>
                                            <li><span>Job Type :</span> Full-Time</li>
                                            <li><span>Location :</span> Software Technology Park Chattogram, Level 6, Agrabad Circle, Chittagong, Bangladesh</li>
                                            <li><span>Working days : </span>6 days.</li>
                                            <li><span>Salary Range : </span>Negotiable.</li>
                                            <li><span>Experience Required :</span> 0–4 Year (Fresh Graduates Encouraged)</li>
                                        </ul>

                                        <p className="mb-30">
                                          We’re looking for a talented Full Stack Web Developer to join our product engineering team. You will be responsible for building modern, scalable web applications, contributing to both frontend and backend development, and ensuring high-quality user experiences. You should be comfortable working across the entire stack and passionate about solving complex engineering challenges.
                                        </p>

                                        <p>
                                           You must be a proactive problem-solver, strong communicator, and team player with a drive to deliver clean, efficient, and reliable solutions.
                                        </p>
                                    </div>

                                    {/* What you'll do */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">What you'll get to do...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Develop, maintain, and optimize full-stack web applications.</li>
                                            <li>Build responsive, user-friendly interfaces using modern frontend frameworks.</li>
                                            <li>Develop robust backend services, REST APIs, and integrations.</li>
                                            <li>Work closely with designers, engineers, and product managers.</li>
                                            <li>Ensure application performance, security, and scalability.</li>
                                            <li>Implement reusable components, modules, and best coding practices.</li>
                                            <li>Manage databases and optimize queries for performance.</li>
                                            <li>Participate in code reviews and technical design discussions.</li>
                                            <li>Troubleshoot production issues and continuously improve system quality.</li>
                                            <li>Collaborate on architectural decisions and new feature development.</li>
                                        </ul>
                                    </div>

                                    {/* Experience section */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Your experience should include...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Strong proficiency in JavaScript/TypeScript.</li>
                                            <li>Experience with modern frontend frameworks (React.js, Next.js, Vue.js).</li>
                                            <li>Backend expertise with Node.js/Express.js or similar frameworks.</li>
                                            <li>Solid understanding of RESTful API design and integration.</li>
                                            <li>Strong database skills with SQL and NoSQL (PostgreSQL, MySQL, MongoDB).</li>
                                            <li>Hands-on experience with Git and collaborative workflows.</li>
                                            <li>Good understanding of authentication, authorization, and session management.</li>
                                            <li>Ability to write secure, efficient, and maintainable code.</li>
                                            <li>Strong problem-solving and debugging skills.</li>
                                            <li>Excellent communication and team collaboration abilities.</li>
                                        </ul>
                                    </div>

                                    {/* You might have */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">You might also have...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Experience with cloud services (AWS, Azure, GCP).</li>
                                            <li>Familiarity with Docker, containerization, and deployment pipelines.</li>
                                            <li>Understanding of microservices and distributed systems.</li>
                                            <li>Experience with GraphQL or WebSockets.</li>
                                            <li>Knowledge of CI/CD pipelines (GitHub Actions, GitLab CI, Jenkins).</li>
                                            <li>Experience with testing frameworks (Jest, Cypress, Playwright).</li>
                                            <li>Interest in system design and scalable architectures.</li>
                                        </ul>
                                    </div>

                                    {/* Benefits */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Great benefits...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Competitive monthly salary with performance reviews.</li>
                                            <li>Opportunity to work on high-scale, real-world applications.</li>
                                            <li>Friendly and collaborative work environment.</li>
                                            <li>Access to learning materials and training sessions.</li>
                                            <li>Flexible working hours.</li>
                                        </ul>
                                    </div>
                                    
                                    {/* ApplyForm */}
                                    <ApplyForm />

                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default WebDeveloper;
